import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "enable-background": "new 0 0 32 32",
  height: "32px",
  id: "Слой_1",
  version: "1.1",
  viewBox: "0 0 32 32",
  width: "32px",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("g", null, null, -1)

import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const color = toRefs(props);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M17.459,16.014l8.239-8.194c0.395-0.391,0.395-1.024,0-1.414c-0.394-0.391-1.034-0.391-1.428,0  l-8.232,8.187L7.73,6.284c-0.394-0.395-1.034-0.395-1.428,0c-0.394,0.396-0.394,1.037,0,1.432l8.302,8.303l-8.332,8.286  c-0.394,0.391-0.394,1.024,0,1.414c0.394,0.391,1.034,0.391,1.428,0l8.325-8.279l8.275,8.276c0.394,0.395,1.034,0.395,1.428,0  c0.394-0.396,0.394-1.037,0-1.432L17.459,16.014z",
      fill: _unref(color),
      id: "Close"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8
  ]))
}
}

})